import { NgModule } from '@angular/core';
import { BooleanPipe } from '../pipes/boolean.pipe';
import { CodePipe } from 'src/pipes/code.pipe';
import { TreePipe } from 'src/pipes/tree.pipe';
import { TextValuePairPipe } from 'src/pipes/text-value-pair.pipe';
import { AttachmentPipe } from 'src/pipes/attachment.pipe';

@NgModule({
  imports: [],
  declarations: [
    AttachmentPipe,
    BooleanPipe,
    CodePipe,
    TreePipe,
    TextValuePairPipe,
  ],
  exports: [
    AttachmentPipe,
    BooleanPipe,
    CodePipe,
    TreePipe,
    TextValuePairPipe,
  ]
})
export class SharedPipeModule { }
